export { StaticRouter as default } from 'react-router';


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-router-dom/es/StaticRouter.js
// module id = 1194
// module chunks = 0